import RichUpdatesItemMedia from './RichUpdatesItemMedia';

export default RichUpdatesItemMedia;



// WEBPACK FOOTER //
// ./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemMedia/index.tsx